export const setConversationTabsStatus = (action, value) => {
  return {
    type: 'SET_CONVERSATION_TABS_STATUS',
    payload: { action, value },
  }
}

export const setConversationTabs = (chatId, data) => {
  return {
    type: 'SET_CONVERSATION_TABS',
    payload: { chatId, data },
  }
}

export const deleteTab = (chatId, tabId) => {
  return {
    type: 'DELETE_TAB',
    payload: { chatId, tabId },
  }
}

export const deleteConversationTabList = (chatId) => {
  return {
    type: 'DELETE_CONVERSATION_TAB_LIST',
    payload: { chatId },
  }
}
